import React from "react";
import { formatPrice } from "../../../utils";

interface PaymentSummaryCardProps {
  type: 'charge' | 'hold' | 'none';
  totalAmount: number;
  subtotal?: number;
  tax?: number;
  appointmentCount: number;
}

export const PaymentSummaryCard: React.FC<PaymentSummaryCardProps> = ({
  type,
  totalAmount,
  subtotal,
  tax,
  appointmentCount
}) => {
  // Don't render if amount is 0 and type is charge or hold
  if ((type === 'charge' || type === 'hold') && totalAmount === 0) return null;

  const configs = {
    charge: {
      bgColor: 'bg-primary-pastel',
      textColor: 'text-primary-pastel-bold',
      borderColor: 'rgb(87, 124, 142)',
      title: 'Due Now',
      description: `This amount will be charged to your payment method today to secure your appointment${appointmentCount > 1 ? 's' : ''}.`
    },
    hold: {
      bgColor: 'bg-secondary-pastel',
      textColor: 'text-secondary-pastel-bold',
      borderColor: 'rgb(232, 188, 158)',
      title: 'On Hold',
      description: `This amount will be temporarily held on your card to secure your appointment${appointmentCount > 1 ? 's' : ''}. The hold will be released or applied according to our cancellation policy.`
    },
    none: {
      bgColor: '#d4edda',
      textColor: '#28a745',
      borderColor: '#28a745',
      title: 'No Payment Required Today',
      description: `Your appointment${appointmentCount > 1 ? 's are' : ' is'} secured. Payment will be collected at your appointment according to our booking policy.`
    }
  };

  const config = configs[type];

  if (type === 'none') {
    return (
      <div 
        className="mb-3 p-3 rounded" 
        style={{ 
          backgroundColor: config.bgColor,
          borderLeft: `4px solid ${config.borderColor}`
        }}
      >
        <div className="d-flex align-items-start">
          <div>
            <p className="mb-1 fw-semibold">{config.title}</p>
            <p className="mb-0 small text-muted">{config.description}</p>
          </div>
        </div>
      </div>
    );
  }

 return (
    <div 
      className={`mb-3 pt-3 pb-2 px-3 rounded ${config.bgColor}`}
      style={{ borderLeft: `4px solid ${config.borderColor}` }}
    >
      <div className="d-flex justify-content-between align-items-start mb-2">
        <h5 className="mb-0 fw-bold">{config.title}</h5>
        <h5 className="mb-0 fw-bold ms-3">{formatPrice(totalAmount)}</h5>
      </div>
      <p className="mb-2 small text-muted">{config.description}</p>
    </div>
  );
};